module.exports = __webpack_public_path__ + "static/media/Goodnest_android_1_preview.7c68dd04.jpg";